import Common from '../../Common';
import Acl from './department/Acl';
import User from "./department/User";

const Department = class extends Common {
	user: InstanceType<typeof User>;
	acl: InstanceType<typeof Acl>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.user = new User(headers);
		this.acl = new Acl(headers)
	}

	async read(companyId: id, id: id) {
		return this.get(`/company/${companyId}/department/${id}`)
	}

	async browse(companyId: id) {
		return this.get(`/company/${companyId}/department`)
	}

	async create(companyId: id, body: {name: string, description: string}) {
		return this.post(`/company/${companyId}/department`, body)
	}

	async update(companyId: id, id: id, body: {name?: string, description?: string}) {
		return this.patch(`/company/${companyId}/department/${id}`, body)
	}

	async delete(companyId: id, id: id) {
		return this.doDelete(`/company/${companyId}/department/${id}`)
	}
}

export default Department
